module.exports = __webpack_public_path__ + "media/images/help/register-to-track-page-a16ce5dda190ae38c9657690be353758.png";